import React, { useState, useEffect } from 'react'
import { db } from './../../Firebase'
import { addCommas } from './../../addComas'


function LineaPobreza() {
    //Data
    const [data, setData] = useState(null)
    // Get data from firebase
    useEffect(() => {
        db.collection('Pruebas').doc('FMI2').collection("componentePobreza").doc("data")
            .onSnapshot(snapshot => {
                setData(snapshot.data())
            }
            )
    }, [])
    return (
        <div>
            { data && (
                <span>*Porcentaje de la población que vive con COP {addCommas(data.LineaPobreza.Pesos)} o menos en el mes (aprox. USD {String(data.LineaPobreza.Dolares).replace(".", ",")})</span>

            )}

        </div>

    )
}

export default LineaPobreza
